module.exports = __webpack_public_path__ + "img/spirit_m.71011b63.png";